<template lang="pug">
.promo-footer-legal
  .promo-footer-legal__copyright
    FooterCopyright(:copyright="copyright")
  .promo-footer-legal__logos
    FooterLogo(v-for="logo in logos", :key="logo.id", :logo="logo")
</template>

<script>
import FooterLogo from "@chronos/battle-teams-2-components/src/components/footer/vue/blocks/FooterLogo";
import FooterCopyright from "@chronos/battle-teams-2-components/src/components/footer/vue/blocks/FooterCopyright";

export default {
  name: "PromosFooterLegal",

  components: {
    FooterLogo,
    FooterCopyright,
  },

  props: {
    copyright: {
      type: String,
      required: true,
    },
    logos: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/promo-footer-legal";
</style>
